import React from 'react';

import { ReactComponent as UploadIcon } from '@assets/icons/upload.svg';

type FileUploadInputProps = {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const FileUploadInput: React.FC<FileUploadInputProps> = ({ onFileChange }) => (
  <div className="relative rounded-lg border-2 border-dashed border-gray-300 p-8 text-center">
    <div className="flex flex-col items-center space-y-4">
      <div className="rounded-full bg-gray-100 p-3">
        <UploadIcon className="text-gray-500" />
      </div>
      <div className="space-y-1">
        <p className="leading-4.5 text-base font-medium text-grey">
          <span className="text-[#00A657]">Click to upload</span> or drag and
          drop
        </p>
        <p className="text-sm font-normal leading-3 text-grey">
          Supported file: PDF, JPG and PNG (max. 5MB)
        </p>
      </div>
    </div>

    <input
      type="file"
      accept=".pdf, .jpg, .png"
      multiple
      className="absolute inset-0 cursor-pointer opacity-0"
      onChange={onFileChange}
    />
  </div>
);

export default FileUploadInput;
